import { render, staticRenderFns } from "./noticeBar.vue?vue&type=template&id=ea48e9e6&scoped=true&"
import script from "./noticeBar.vue?vue&type=script&lang=js&"
export * from "./noticeBar.vue?vue&type=script&lang=js&"
import style0 from "./noticeBar.vue?vue&type=style&index=0&id=ea48e9e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea48e9e6",
  null
  
)

export default component.exports